<template>
  <div id="payscene">
    <div id="pshead">
      {{data.title?data.title:$t('lang.multipay')}}
      <!-- {{$store.state.iscn?'支付无界  随你所有':'Multi payments '}} -->
      <label>{{$store.state.iscn?'线上线下一体化，满足全功能支付':'Online and offline integration to meet full-featured payment'}}</label>
    </div>
    <div v-if="data.data.length==3" id="psct">
      <div>
        <label>{{data.data[0].label}}</label>
        <img :src="data.data[0].pic"/>
      </div>
      <span>
        <div>
          <label>{{data.data[1].label}}</label>
          <img :src="data.data[1].pic"/>
        </div>
        <div>
          <label>{{data.data[2].label}}</label>
          <img :src="data.data[2].pic"/>
        </div>
      </span>
    </div>
    <div id="psct1" v-if="data.data.length==2">
      <div v-for="item in data.data" :key="item.label">
        <label>{{item.label}}</label>
        <img :src="item.pic"/>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: '',
  props: {
    data: Object
  },
  watch: {
 
  },
  data () {
    return {
      
    }
  },
  computed: {
    lang () {
      return localStorage.lang
    }
  },
  methods: {

  },
  mounted () {
  
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
#payscene {
  background: #F7F8F8;
  overflow: hidden;
}

#pshead {
  background: white;
  text-align: center;
  font-size: .6rem;
  color: #363636;
  height: 2.26rem;
  overflow: hidden;
  padding-top: .97rem;
  font-weight: bold;
}
#pshead label {
  font-size: .24rem;
  font-weight: normal;
  display: block;
}
#psct {
  background-image: url('../assets/pic/psbg.png');
  background-size: 100% 100%;
  background-color: #fff;
  text-align: center;
  padding-top: 1.5rem;
  padding-bottom: 1.29rem;
}
#psct div {
  display: inline-block;
  width: 6.06rem;
  height: 7.8rem;
  overflow: hidden;
  margin-right: .2rem;
}
#psct img {
  width: 100%;
  height: 100%;
}
#psct span {
  display: inline-block;
  vertical-align: top;
}
#psct span div {
  height: 3.8rem;
  width: 6.06rem;
  overflow: hidden;
  display: block;
  margin-bottom: .21rem;
}
#psct label {
  position: absolute;
  width: 6.06rem;
  color: white;
  height: .78rem;
  line-height: .78rem;
  background: rgba(0, 0, 0, .9);
  font-size: .3rem;
  margin-top: 7.02rem;
}
#psct span label {
  margin-top: 3.02rem;
}

#psct1 {
  background-image: url('../assets/pic/psbg.png');
  background-size: 100% 100%;
  background-color: #fff;
  text-align: center;
  overflow: hidden;
  height: 9.94rem;
}
#psct1 div {
  width: 6rem;
  height: 6.96rem;
  overflow: hidden;
  display: inline-block;
  margin: 1.34rem .125rem 0 .125rem;
}
#psct1 label {
  position: absolute;
  height: .6rem;
  display: block;
  text-align: center;
  width: 6rem;
  line-height: .6rem;
  font-size: .24rem;
  font-weight: 500;
  color: #F4F4F4;
  background: rgba(0, 0, 0, 0.75);
  margin-top: 6.37rem;
}
#psct1 img {
  margin: 0;
  width: 6rem;
  height: 6.96rem;
}

</style>
